<template>
	<BaseCard class="flex-1 p-5">
		<div class="bg-fill-secondary h-11 w-11 rounded-full p-2 *:h-7 *:w-7">
			<slot />
		</div>
		<div class="text-label-primary mt-3 text-base font-medium">{{ value }}</div>
		<div class="text-label-secondary mt-1.5 text-xs font-medium uppercase">
			{{ label }}
		</div>
	</BaseCard>
</template>
<script setup lang="ts">
import BaseCard from '@/components/BaseCard.vue'

defineProps<{
	value: number
	label: string
}>()
</script>
